(function () {
  const moneyFromText = (value) => value || '';
  const cartBase = () => {
    const root = window.Shopify?.routes?.root || '/';
    return root.endsWith('/') ? root : root + '/';
  };
  const displayCartCount = (cart) => (cart?.items || []).reduce((total, item) => {
    return total + (item.properties?._hlm_weight_unit === '10g' ? 1 : Number(item.quantity || 0));
  }, 0);
  const updateCartCounts = (cart) => {
    const count = displayCartCount(cart);
    document.querySelectorAll('[data-cart-count]').forEach((node) => { node.textContent = String(count); });
    document.querySelectorAll('.floating-cart').forEach((node) => {
      node.classList.toggle('has-items', count > 0);
      node.setAttribute('aria-label', count > 0 ? `View your cart, ${count} item${count === 1 ? '' : 's'}` : 'View your empty cart');
    });
    return count;
  };
  let toastTimer;
  const showCartToast = (message, isError = false) => {
    const toast = document.querySelector('[data-cart-toast]');
    if (!toast) return;
    window.clearTimeout(toastTimer);
    const text = toast.querySelector('[data-cart-toast-message]');
    if (text) text.textContent = message;
    toast.classList.toggle('is-error', isError);
    toast.hidden = false;
    window.requestAnimationFrame(() => toast.classList.add('is-visible'));
    toastTimer = window.setTimeout(() => {
      toast.classList.remove('is-visible');
      window.setTimeout(() => { toast.hidden = true; }, 220);
    }, isError ? 6500 : 4200);
  };
  const readCart = async () => {
    const response = await fetch(cartBase() + 'cart.js', { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('Your cart could not be refreshed.');
    return response.json();
  };
  const addedToCart = (cart, productTitle) => {
    updateCartCounts(cart);
    showCartToast(`${productTitle || 'Item'} added to your cart.`);
    document.dispatchEvent(new CustomEvent('hlm:cart-updated', { detail: { cart } }));
  };

  window.HLMCartUI = { readCart, update: updateCartCounts, added: addedToCart, show: showCartToast };

  const bindAjaxProductForms = (scope) => {
    scope.querySelectorAll('form[action*="/cart/add"]').forEach((form) => {
      if (form.dataset.hlmAjaxBound || form.closest('[data-kg-product]')) return;
      form.dataset.hlmAjaxBound = 'true';
      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        if (form.dataset.hlmAjaxBusy === 'true') return;
        const button = event.submitter || form.querySelector('button[type="submit"], input[type="submit"]');
        const originalLabel = button ? (button.tagName === 'INPUT' ? button.value : button.textContent) : '';
        form.dataset.hlmAjaxBusy = 'true';
        if (button) {
          button.disabled = true;
          if (button.tagName === 'INPUT') button.value = 'ADDING…';
          else button.textContent = 'ADDING…';
        }
        let succeeded = false;
        try {
          const response = await fetch(cartBase() + 'cart/add.js', {
            method: 'POST', credentials: 'same-origin', headers: { Accept: 'application/json' }, body: new FormData(form)
          });
          const result = await response.json();
          if (!response.ok) throw new Error(result.description || result.message || 'This item could not be added.');
          const cart = await readCart();
          addedToCart(cart, result.product_title || result.title);
          succeeded = true;
          if (button) {
            if (button.tagName === 'INPUT') button.value = 'ADDED ✓';
            else button.textContent = 'ADDED ✓';
          }
        } catch (problem) {
          showCartToast(problem.message || 'This item could not be added. Please try again.', true);
        } finally {
          window.setTimeout(() => {
            form.dataset.hlmAjaxBusy = 'false';
            if (button) {
              button.disabled = false;
              if (button.tagName === 'INPUT') button.value = originalLabel;
              else button.textContent = originalLabel;
            }
          }, succeeded ? 900 : 0);
        }
      });
    });
  };

  const initFooterMenus = () => {
    const menus = Array.from(document.querySelectorAll('.footer-menu'));
    if (!menus.length) return;
    let mobile;
    const update = () => {
      const nextMobile = window.innerWidth <= 760;
      if (nextMobile === mobile) return;
      menus.forEach((menu) => { menu.open = !nextMobile; });
      mobile = nextMobile;
    };
    window.addEventListener('resize', update);
    update();
  };

  document.addEventListener('DOMContentLoaded', function () {
    bindAjaxProductForms(document);
    initFooterMenus();
    if ('MutationObserver' in window) {
      new MutationObserver((records) => records.forEach((record) => record.addedNodes.forEach((node) => {
        if (node.nodeType === 1) bindAjaxProductForms(node);
      }))).observe(document.body, { childList: true, subtree: true });
    }
    // Quantity controls
    document.querySelectorAll('[data-product-root]').forEach((root) => {
      const input = root.hasAttribute('data-kg-product') ? null : root.querySelector('input[name="quantity"]');
      root.querySelector('[data-qty-minus]')?.addEventListener('click', () => {
        if (!input) return;
        input.value = Math.max(1, parseInt(input.value || '1', 10) - 1);
      });
      root.querySelector('[data-qty-plus]')?.addEventListener('click', () => {
        if (!input) return;
        input.value = Math.max(1, parseInt(input.value || '1', 10) + 1);
      });

      const select = root.querySelector('[data-variant-select]');
      const price = root.querySelector('[data-product-price]');
      const availability = root.querySelector('[data-availability]');
      const add = root.querySelector('[data-add-button]');
      const mainImage = root.querySelector('.js-main-product-image');
      const badge = root.querySelector('[data-discount-badge]');
      const stickyPrice = root.querySelector('[data-mobile-purchase] strong');

      const activateImage = (imageUrl, variantId) => {
        if (imageUrl && mainImage) {
          // Shopify's image_tag outputs a responsive srcset. Updating only src can
          // leave the browser displaying the old variant image, so clear the old
          // responsive candidates before applying the selected variant image.
          mainImage.removeAttribute('srcset');
          mainImage.removeAttribute('sizes');
          mainImage.src = imageUrl;
        }
        root.querySelectorAll('.product-thumb').forEach((t) => {
          const sameVariant = variantId && t.dataset.variantId === String(variantId);
          const sameImage = imageUrl && t.dataset.productImage === imageUrl;
          t.classList.toggle('is-active', Boolean(sameVariant || (!variantId && sameImage)));
        });
      };

      const syncSelectedVariant = () => {
        if (!select) return;
        const option = select.options[select.selectedIndex];
        const priceReady = Number(option.dataset.priceCents) > 0;
        const displayPrice = priceReady ? moneyFromText(option.dataset.price) : 'Price unavailable';
        if (price) price.textContent = displayPrice;
        if (stickyPrice) stickyPrice.textContent = displayPrice;
        if (availability) {
          availability.textContent = priceReady ? 'Available' : 'Price unavailable — please contact us';
          availability.classList.toggle('is-unavailable', !priceReady);
        }
        if (add) {
          add.disabled = !priceReady;
          add.textContent = priceReady ? 'ADD TO CART' : 'PRICE UNAVAILABLE';
        }
        if (badge) {
          const badgeText = (option.dataset.badge || '').trim();
          badge.textContent = badgeText;
          badge.hidden = !priceReady || !badgeText;
        }
        activateImage(option.dataset.image, option.value);
      };

      if (select) select.addEventListener('change', syncSelectedVariant);

      root.querySelectorAll('[data-product-image]').forEach((thumb) => {
        thumb.addEventListener('click', () => {
          if (thumb.dataset.variantId && select) {
            const matching = Array.from(select.options).find((option) => option.value === thumb.dataset.variantId);
            if (matching) {
              select.value = matching.value;
              select.dispatchEvent(new Event('change', { bubbles: true }));
              return;
            }
          }
          activateImage(thumb.dataset.productImage, '');
        });
      });
    });

    // Collection sorting
    document.querySelectorAll('[data-auto-submit]').forEach((el) => {
      el.addEventListener('change', () => el.form && el.form.submit());
    });

    // Close mobile drawer after navigation
    document.querySelectorAll('.mobile-drawer a').forEach((link) => {
      link.addEventListener('click', () => {
        const details = link.closest('details');
        if (details) details.open = false;
      });
    });

    // Predictive search
    const searchInput = document.querySelector('.js-predictive-input');
    const results = document.querySelector('[data-predictive-results]');
    let timer;
    if (searchInput && results) {
      searchInput.addEventListener('input', function () {
        clearTimeout(timer);
        const q = this.value.trim();
        if (q.length < 2) {
          results.hidden = true;
          results.innerHTML = '';
          return;
        }
        timer = setTimeout(async () => {
          try {
            const base = window.Shopify?.routes?.root || '/';
            const response = await fetch(`${base}search/suggest?section_id=predictive-search&q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last`);
            if (!response.ok) throw new Error('Search unavailable');
            const html = await response.text();
            if (searchInput.value.trim() !== q) return;
            const parsed = new DOMParser().parseFromString(html, 'text/html');
            const section = parsed.querySelector('#shopify-section-predictive-search');
            if (!section) throw new Error('Search response unavailable');
            results.replaceChildren(...Array.from(section.childNodes).map((node) => document.importNode(node, true)));
            results.hidden = false;
          } catch (e) {
            results.hidden = true;
          }
        }, 220);
      });
      document.addEventListener('click', (event) => {
        if (!event.target.closest('.search-shell')) results.hidden = true;
      });
    }
  });

  document.addEventListener('shopify:section:load', (event) => bindAjaxProductForms(event.target));
})();
